module.exports = "<main class=\"main\">\n    <router-outlet></router-outlet>\n</main>\n<footer class=\"footer\">\n\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/simple-layout.component.html
// module id = ./src/app/layouts/simple-layout.component.html
// module chunks = main